import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Stepper, Typography, Container } from "@mui/material";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CorporateAccount from "../accountDetails/personalAccount/personalAccount";
import OtpVerification from "component/authentication/signUp/accountDetails/otpVerification/OtpVerification";
import CompanyVerification from "../companyRegistration/companyVerification/companyVerification";
import VehicleRegistration from "../vehicleRegistration/VehicleRegistration";
import { ColorlibStepIcon, ColorlibConnector } from "./Customization";
import AuthHeader from "component/authentication/UI/authHeader/auth-header";
import SignupFooter from "component/authentication/UI/signup-footer/signup-footer";
import GlobalSnackBar from "UI/snackbar/GlobalSnackBar";
import { v4 as uuidv4 } from 'uuid';
import "./stepper.scss";

const SignUp = () => {
  const { state }: any = useLocation()
  const [activeStep, setActiveStep] = useState(state?.stepperState ?? 0);
  const [userId, setUserId] = useState("");
  const [verificationEmail, setVerificationEmail] = useState("");
  const [toggleSnackbar, setToggleSnackbar] = useState({ message: "", isToggle: false, mode: "" });

  const handleStepNext = () => {
    setActiveStep(activeStep + 1);
  };
  let stepperArray: string[] = ["Account Details", "Company Verification", " Vehicle Registration"];
  return (
    <Box sx={{ backgroundColor: "#f0f3fb", minHeight: "100vh" }}>
      <AuthHeader />
      <Box sx={{ position: "relative", width: "100%", mt: 2 }}>
        {toggleSnackbar.isToggle && (
          <GlobalSnackBar isOpenSnack={toggleSnackbar} setIsOpenSnack={setToggleSnackbar} />
        )}
      </Box>
      <Container fixed sx={{minHeight:{sm:'60vh',md:'80vh',lg:'95vh'}}}>
        <Box className="stepper">
          <Box className="title">
            <Typography className="main-heading">Sign up for DriverTok</Typography>
            <Typography className="sub-heading">
              In the wrong place? Register for {" "}
              <Link className="link" to="/authentication/signup/Corporate">
                Corporate
              </Link>
              {" "}or for a {" "}
              <Link className="link" to="/authentication/signup/Commercial">
                Commercial
              </Link>
              {" "}account.
            </Typography>
          </Box>

          <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
            {stepperArray.map((value: string) => {
              return (
                <Step key={uuidv4()}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}>{value}</StepLabel>
                </Step>
              );
            })}
          </Stepper>

          <Box className="stepper-content">
            {activeStep.toString() === "0" && (
              verificationEmail ? (
                <OtpVerification
                  email={verificationEmail}
                  nextStepHandler={handleStepNext}
                  onCancel={() => setVerificationEmail("")}
                  setToggleSnackbar={setToggleSnackbar}
                />
              ) : (
                <CorporateAccount
                  setUserId={setUserId}
                  setToggleSnackbar={setToggleSnackbar}
                  onSignupSuccess={(email: string) => setVerificationEmail(email)}
                />
              )
            )}
            {activeStep.toString() === "1" && (
              <CompanyVerification
                userId={userId || state?.userId}
                nextStepHandler={handleStepNext}
                setToggleSnackbar={setToggleSnackbar}
              />
            )}
            {activeStep.toString() === "2" && (
              <VehicleRegistration userId={userId || state?.userId} setToggleSnackbar={setToggleSnackbar} />
            )}
          </Box>
        </Box>
      </Container>
      <SignupFooter />
    </Box>
  );
};
export default SignUp;
